export default "__VITE_ASSET__Dh68uUlu__"